import { DebitCardWithTruck } from '../../../../../../../types/apiTypes';

interface CardStatusBadgeProps {
  card: DebitCardWithTruck | null;
}

const CardStatusBadge = ({ card }: CardStatusBadgeProps) => {
  if (!card) return <p className="text-[14px] text-primary">-</p>;

  if (card.is_cancelled) {
    return (
      <div className="flex w-[50%] max-w-[50%] flex-row items-center justify-start">
        <div className="flex items-center justify-center rounded-[20px] border-[1px] border-danger bg-red-100 px-3 py-1">
          <p className="text-[14px] text-danger">Cancelled</p>
        </div>
      </div>
    );
  } else if (card.frozen) {
    return (
      <div className="flex w-[50%] max-w-[50%] flex-row items-center justify-start">
        <div className="flex items-center justify-center rounded-[20px] border-[1px] border-blue-400 bg-blue-100 px-3 py-1">
          <p className="text-[14px] text-blue-400">Frozen</p>
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex w-[50%] max-w-[50%] flex-row items-center justify-start">
        <div className="flex items-center justify-center rounded-[20px] border-[1px] border-ctadarkgreen bg-ctaactivegreen px-3 py-1">
          <p className="text-[14px] text-ctadarkgreen">Active</p>
        </div>
      </div>
    );
  }
};

export default CardStatusBadge;
